import { AdjustTermKey } from '@aloft/toolkit-shared';

export const STUDY_TERMS: AdjustTermKey[] = [
  'aboveGradeBedroomCount',
  'aboveGradeFullBathCount',
  'aboveGradeHalfBathCount',
  'carportParkingSpacesCount',
  'cooling',
  'design',
  'designAttachmentType',
  'garageParkingSpacesCount',
  'greenEnergyEfficient',
  'grossLivingArea',
  'heating',
  'location',
  'pool',
  'porchPatioDeck',
  'site',
  'totalBasementArea',
  'view',
];
